export default "/_next/static/sounds/trim-page-turn-2-138e156cfb5c0fe39c3670fb336ed4d2.mp3";